import { useGaugeState } from "@mui/x-charts"

import { ANGULAR_OVERSHOOT_DEG } from "./helpers"

interface MuiGaugeBgArcProps {
  color: string
  filter: string
  startAngleRad: number
  endAngleRad: number
}

const MuiGaugeBgArc = ({
  color,
  filter,
  startAngleRad,
  endAngleRad,
}: MuiGaugeBgArcProps) => {
  const { innerRadius, outerRadius, cx, cy } = useGaugeState()
  const meanRadius = (innerRadius + outerRadius) / 2
  const arcWidth = outerRadius - innerRadius
  const overshootRad = (ANGULAR_OVERSHOOT_DEG * Math.PI) / 180

  const startAngle = startAngleRad - overshootRad
  const endAngle = endAngleRad + overshootRad

  const x1 = cx + meanRadius * Math.sin(startAngle)
  const y1 = cy - meanRadius * Math.cos(startAngle)
  const x2 = cx + meanRadius * Math.sin(endAngle)
  const y2 = cy - meanRadius * Math.cos(endAngle)

  // large-arc-flag=1 because the arc spans > 180°
  const d = `M ${x1} ${y1} A ${meanRadius} ${meanRadius} 0 1 1 ${x2} ${y2}`

  return (
    <path
      d={d}
      style={{
        fill: "none",
        stroke: color,
        strokeWidth: arcWidth,
        strokeLinecap: "round",
        filter: `drop-shadow(0px 0px 5px ${filter})`,
      }}
    />
  )
}

export default MuiGaugeBgArc
